import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWave: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWave"><Path d="M12.75 19.5H16.25V10.75H22V12.25H17.75V21H11.25V4.5H7.75V12.75H2V11.25H6.25V3H12.75V19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWave;
